module.exports = "precision mediump float;\nuniform sampler2D uSampler;\nvarying vec2 vTextureCoord;\n\nuniform int numberOfPixels;\n\n// maybe lower this value to maintain memory use better.\nuniform vec4 pixels[128];\nuniform vec4 dimensions;\n\n\nint isMatch(vec4 px){\n\tint inverse = 0;\n\n\tif( \n\t\tvTextureCoord.x > px.x && \n\t\tvTextureCoord.x <= (px.x + px[2]) &&\n\t\tvTextureCoord.y > px.y &&\n\t\tvTextureCoord.y <= (px.y + px[3])\n\t){\n\t\t// inverse\n\t\tinverse = 1;\n\t}\n\n\treturn inverse;\n}\n\nvoid main (void)\n{\n\n\tvec4 col = texture2D(uSampler, vTextureCoord);\n\tint inverse = 0;\n\n\tgl_FragColor = col;\n\t\n}\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/shaders/artifacts.glsl
 ** module id = 100
 ** module chunks = 0
 **/